import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const SvgContainer = styled.svg`
  width: ${props => props.size? props.size + "px" : "17px"};
  height: ${props => props.size? props.size + "px" : "17px"};
  path{
    fill: ${props => props.color? props.color: Variables.colors.black};
  }
`